import { render, staticRenderFns } from "./CareerPath.vue?vue&type=template&id=7e894ce8&scoped=true&"
import script from "./CareerPath.vue?vue&type=script&lang=ts&"
export * from "./CareerPath.vue?vue&type=script&lang=ts&"
import style0 from "./CareerPath.vue?vue&type=style&index=0&id=7e894ce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e894ce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VBtn,VIcon,VSkeletonLoader})
